$(function () {

  // スクロールトップ
  $(window).on('load', function () {
    const btn = $('#toTop')
    const onClass = 'btn_top_on'
    const scrollY = window.scrollY

    if (scrollY <= 300) {
      btn.removeClass(onClass);
    }
    let moveFlag = false
    btn.on('click', function () {
      if (moveFlag === false) {
        moveFlag = true
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        setTimeout(function () {
          moveFlag = false
        }, 1000);
      }
    });
  });

  $(window).on('scroll', function () {
    const btn = $('#toTop')
    const onClass = 'btn_top_on'
    const scrollY = window.scrollY

    // トップ時に非表示
    if (scrollY <= 300) {
      btn.removeClass(onClass);
    } else {
      btn.addClass(onClass);
    }

    // フッター手前でストップ
    scrollHeight = $(document).height();
    scrollPosition = $(window).height() + $(window).scrollTop();
    footHeight = $("footer").innerHeight();
    if (scrollHeight - scrollPosition <= footHeight) {
      btn.css({
        position: "absolute",
        bottom: "1.2rem",
      });
    } else {
      btn.css({
        position: "fixed",
        bottom: "2rem",
      });
    }
  });

  $('input.search').on('input', function () {
    if ($('input.search').val() != '') {
      $('input.submit').addClass('visible');
    }
    if ($('input.search').val() == '') {
      $('input.submit').removeClass('visible');
    }
  });
});
